import React, { useEffect, useState} from "react";
import { useForm, Controller} from "react-hook-form";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import Header from "../components/Header";
import { useAxios } from "../services/useAxios";
import {alert, confirm} from "../components/MegConfirmAlert";
import base64 from "base-64";
import utf8 from "utf8";
import KakaoLogin from "react-kakao-login";
import {GoogleLogin} from "@react-oauth/google";
import {GoogleOAuthProvider} from "@react-oauth/google";
import { useGoogleLogin } from '@react-oauth/google';
import NaverLogin from 'react-naver-login';
import FacebookLogin from '@greatsumini/react-facebook-login';
import JoinTerms from "./JoinTerms"
import Join from "./Join"
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { BsXLg } from "react-icons/bs";
import AppleSignin from 'react-apple-signin-auth';
import LineLogin from "../components/LineLogin";
import { Display } from "react-bootstrap-icons";
import logo from "../images/logo.svg";

export default function LogIn(){    
    const { t } = useTranslation();
    const navigate = useNavigate();  
    const userData = localStorage.getItem("user");
    const lastLogin = localStorage.getItem("lastLogin");
    
    
    const [tooltipShow, setTooltipShow] = useState(lastLogin!==null);

    const [modalShow, setModalShow] = useState(false);
    const [isJoinOpen, setJoinOpen] = useState(false);
    const [isFindPwOpen, setFindPwOpen] = useState(false);
    const [isFindPwCert, setFindPwCert] = useState(false);
    const [isFindPw, setFindPw] = useState(false);
    const [isTermsOpen, setTermsOpen] = useState(false);
    const [socialUserInfo, setSocialUserInfo] = useState({});
    const [emailUserInfo, setEmailUserInfo] = useState({});
    
    const {register, handleSubmit, getValues, setFocus, formState, watch }= useForm({mode: 'onChange'});

    const{errors} = formState;
    
    const [request] = useAxios();
    const location = useLocation();
    const [mode, setMode] = useState('login');
    const [idCheck, setIdCheck] = useState(false);
    const [termsItems, setTermsItems] = useState([]);
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    const setTerms = (termsItems) => {
        setTermsItems(termsItems)
        setTermsOpen(false)
        if(mode === 'join'){            
            setIdCheck(true)
        }else{
            setJoinOpen(true)
        }
        
    }

    function parseJwt(token) {
        let base64Url = token.split('.')[1]
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        let jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
        )
        return JSON.parse(jsonPayload)
      }

    const setLogin = (response, type) => {
        console.log(response)
        localStorage.setItem("accessToken", response.data.result.token.accessToken);
        localStorage.setItem("refreshToken", response.data.result.token.refreshToken);
        let accessToken = response.data.result.token.accessToken;
        let payload = accessToken.substring(accessToken.indexOf(".") + 1, accessToken.lastIndexOf("."));
        let userInfo = utf8.decode(base64.decode(payload));

        localStorage.setItem("user", userInfo);
        localStorage.setItem("lastLogin", type);
        
        if(location.state && location.state.from){                   
            navigate(location.state.from.pathname,{state :location.state.from.state});
        }else{
            navigate('/');
        }
        
    }
    useEffect(() => {
       if(userData!== null){
        navigate("/");
       }
      }, []);

    const hideModal =  () =>{
        setMode('login') 
        setModalShow(false)
    }
    
    const GoogleLoginButton = () => {
        const signIn = useGoogleLogin({
            onSuccess: async (res) => { 
                const response = await request.post("/app/member/snsLoginAPI", {
                    socialSe: "GOOGLE"
                  },{ headers : {
                    tk : res.access_token
                  }});
                  if(response.data.result){
                    if (response.data.result.isLogin) {
                        setLogin(response,'G');
                    }else if(response.data.result.redirectJoin){
                        setMode('snsJoin')       
                        setTermsOpen(true) 
                        let userInfo = response.data.result.socialUserInfo; 
                        userInfo.mberTy = 'G'
                        userInfo.crtfcTy = 'G'
                        setSocialUserInfo(userInfo)
                    }else{
                        alert(response.data.resultMessage);
                    }
                 }

            },
            onError: (error) =>{ console.log(error);}
        });
    
        return (
            
            <button onClick={() => signIn()} className="snsBtn snsLinkGg">{t(`Message.login_google_login_title`)}</button>
        );
    };
    const kakaoOnSuccess = async (data)=>{        
        const idToken = data.response.access_token  // 엑세스 토큰 백엔드로 전달
        const response = await request.post("/app/member/snsLoginAPI", {
            socialSe: "KAKAO"
        },{ headers : {
            tk : idToken
        }});
        if(response.data.result){
            if (response.data.result?.isLogin) {
                setLogin(response, 'K');
            }else if(response.data.result.redirectJoin){        
                setMode('snsJoin')       
                setTermsOpen(true) 
                let userInfo = response.data.result.socialUserInfo; 
                userInfo.mberTy = 'G'
                userInfo.crtfcTy = 'K'
                setSocialUserInfo(userInfo)
            }
            else{       
                alert(response.data.resultMessage);
            }
        }
        
    }

  const naverOnSuccess = async (data)=>{        
    const idToken = data.id
    console.log(data)
    const response = await request.post("/app/member/snsLoginAPI", {
        socialSe: "MNAVER"
      },{ headers : {
        tk : idToken
      }});
      if(response.data.result){
        if (response.data.result.isLogin) {
            setLogin(response, 'N');
        }else if(response.data.result.redirectJoin){
            setMode('snsJoin')       
            setTermsOpen(true) 
            let userInfo = response.data.result.socialUserInfo;
            userInfo.name=data.name
            userInfo.email = data.email
            userInfo.mberTy = 'G'
            userInfo.crtfcTy = 'N'
            setSocialUserInfo(userInfo)
        }else{
            alert(response.data.resultMessage);
        }
     }
     
  }

  const faceBookOnSuccess = async (data)=>{        
    const idToken = data.accessToken;

    const response = await request.post("/app/member/snsLoginAPI", {
        socialSe: "MFACEBOOK"
      },{ headers : {
        tk : idToken
      }});
      if(response.data.result){
        console.log(response.data)
        if (response.data.result.isLogin) {
            setLogin(response,'F');
        }else if(response.data.result.redirectJoin){
            setMode('snsJoin')       
            setTermsOpen(true) 
            let userInfo = response.data.result.socialUserInfo; 
            userInfo.mberTy = 'G'
            userInfo.crtfcTy = 'F'
            setSocialUserInfo(userInfo)
        }else{
            alert(response.data.resultMessage);
        }
    }
     
  }

  const appleOnSucess = async (data)=>{
    const result = parseJwt(data.authorization.id_token)
    const idToken = result.sub;

    const response = await request.post("/app/member/snsLoginAPI", {
        socialSe: "APPLE",
        id : result.sub
      },{ headers : {
        tk : idToken
      }});
      if(response.data.result){
        if (response.data.result.isLogin) {
            setLogin(response,'A');
        }else if(response.data.result.redirectJoin){
            setMode('snsJoin')       
            setTermsOpen(true) 
            let userInfo = response.data.result.socialUserInfo;
            userInfo.name=result.name
            userInfo.email = result.email
            userInfo.mberTy = 'G'
            userInfo.crtfcTy = 'A'
            setSocialUserInfo(userInfo)
        }else{
            alert(response.data.resultMessage);
        }
    }
  }



  const lineOnSucess = async (data)=>{
    const idToken = data.access_token;
    
    const response = await request.post("/app/member/snsLoginAPI", {
        socialSe: "LINE"        
      },{ headers : {
        tk : idToken
      }});
      
      if(response.data.result){
        if (response.data.result.isLogin) {
            setLogin(response,'L');
        }else if(response.data.result.redirectJoin){
            setMode('snsJoin')       
            setTermsOpen(true) 
            let userInfo = response.data.result.socialUserInfo;     
            userInfo.mberTy = 'G'
            userInfo.crtfcTy = 'L'
            setSocialUserInfo(userInfo)
        }else{
            alert(response.data.resultMessage);
        }
    }
  }


  const onSubmit3 = async data=> {
    if(!isFindPwCert && !isFindPw){
        const response = await request.post("/app/member/sendPwdResetCertNumAPI", {
            email : data.email
        });        
        if(response.data.resultCode === 200){    
            setFindPwCert(true)
        }else{
            alert(response.data.resultMessage);
            setFindPwCert(true)
        }
    }else if(isFindPwCert){
      
        const response = await request.post("/app/member/getEmailCertNumConfirmAPI", {
            email : data.email,
            certNum : data.certCode
        });  
         
        if(response.data.resultCode === 200){    
            setFindPwCert(false)
            setFindPw(true)
        }else{
            alert(response.data.resultMessage);
        }
    }else if(isFindPw){
        const response = await request.post("/app/member/procPwdResetAPI", {
            userId : data.email,
            certCode : data.certCode,
            password : data.newPassword
        }); 
        if(response.data.resultCode === 200){    
            alert(response.data.resultMessage);
            setFindPwCert(false)
            setFindPwOpen(false)
            setFindPw(false)
        }else{
            alert(response.data.resultMessage);
        }
    }
  }

  const onSubmit2 = async data=> {
    
    const response = await request.post("/app/member/getEmailCertNumConfirmAPI", {
        email : emailUserInfo.userId,
        certNum : data.certNum
    });    
    if(response.data.resultCode === 200){        

        const response2 = await request.post("/app/member/addPersnalSignUpAPI", {
            userId : emailUserInfo.userId,
            password : emailUserInfo.password,
            email : emailUserInfo.userId,
            mberTy : 'G',
            crtfcTy : 'D',
            useStplatAgreAt : termsItems.includes(1)?'Y':'N',
            indvdlinfoColctUseAgreAt : termsItems.includes(2)?'Y':'N',
            emailRecptnAgreAt : termsItems.includes(3)?'Y':'N',
            smsRecptnAgreAt : termsItems.includes(4)?'Y':'N',
        });
        if(response2.data.resultCode === 200){
            window.location.href="/JoinSuccess";
            return
        }else{
            alert(response.data.resultMessage);
        }
        
    }else{
        alert(response.data.resultMessage);
    }
  }

    const onSubmit = async data=> {
       
        if(idCheck){
            if(mode === 'login'){
                localStorage.setItem("accessToken", "");
                localStorage.setItem("refreshToken", "");

                const response = await request.post("/app/member/shopLoginAPI", data);
                console.log(response)
                if (response.data.result.isLogin) {
                    setLogin(response,'');
                }else{
                    alert(response.data.resultMessage);
                }
            }else{
                const response2 = await request.post("/app/member/procSendEmailCertNumAPI", {
                    email : data.userId
                });
               
                if(response2.data.resultCode === 200){
                    setEmailUserInfo(data)
                    setModalShow(true)    
                }else{
                    alert(response2.data.resultMessage);
                }
            }
        }else{
            const response = await request.post("/app/member/getUserIdChkAPI", data);
           
            if(response.data.resultCode === 200){
                if(response.data.result.userIdRst){
                    setIdCheck(true);
                   
                }else{         
                    setMode('join')       
                    setTermsOpen(true)                    
                }
            }else{
                alert(response.data.resultMessage);
            }
        }

    }
    useEffect(() => {
        if(mode === 'login'){
            setFocus("password");
        }
    }, [idCheck]);

    return(
        
        <div>
        {!isTermsOpen && !isJoinOpen && userData === null?(
        <div className="backGround bgBlue">
            <Header type="search" pageTitle={mode !== 'login'?t(`Message.social_sign_up_info_input_join`):t(`Message.login_screen_login`)}/>
            <div className="loginArea">
                <div></div>
                <div className="loginSnsBtnWr">
                    <div className="loginTxt">
                        <img src={logo} alt="logo" />
                        <p className="tit">SALEE {mode !== 'login'?t(`Message.social_sign_up_info_input_join`):t(`Message.login_screen_login`)}</p>
                        <p className="cont">{t(`Message.login_instructions`)}</p>
                    </div>
                    <ul className="snsListWr">
                        <li className="snsList">
                        <FacebookLogin
                            appId="799381328717879"
                            onSuccess={faceBookOnSuccess}
                            onFail={(error) => {
                                console.log('Login Failed!', error);
                            }}                                
                            render={({ onClick, logout }) => (
                                <button className="snsBtn snsLinkFb" onClick={onClick} >페이스북 로그인</button>                                   
                            )}
                            />
                            {tooltipShow && lastLogin === 'F'?(
                            <div className="tooltipWr">
                                <p className="txt">최근 사용한 로그인 방법입니다.</p>
                                <button type="butotn" className="xBtn" onClick={(e)=>setTooltipShow(false)}><BsXLg /></button>
                            </div>
                            ):null}
                        </li>
                        <li className="snsList">
                        <GoogleOAuthProvider clientId="110023402547-p6lqgfftfqdksgu0rm6btm6k5asuj35g.apps.googleusercontent.com">
                            <GoogleLoginButton />
                        </GoogleOAuthProvider>
                            
                            {tooltipShow && lastLogin === 'G'?(
                            <div className="tooltipWr">
                                <p className="txt">최근 사용한 로그인 방법입니다.</p>
                                <button type="butotn" className="xBtn" onClick={(e)=>setTooltipShow(false)}><BsXLg /></button>
                            </div>
                            ):null}
                        </li>
                        <li className="snsList">
                        <NaverLogin 
                            clientId="OiCm1IOGJg3OABfcXuZm"
                            callbackUrl="https://m.salee.co.kr/Login"
                            render={(props) => <button className="snsBtn snsLinkNv" onClick={props.onClick}>네이버 로그인</button> }
                            onSuccess={naverOnSuccess}
                            onFailure={(result) => console.error(result)}
                        />
                            {tooltipShow && lastLogin === 'N'?(
                            <div className="tooltipWr">
                                <p className="txt">최근 사용한 로그인 방법입니다.</p>
                                <button type="butotn" className="xBtn" onClick={(e)=>setTooltipShow(false)}><BsXLg /></button>
                            </div>
                            ):null}                    
                        </li>
                        <li className="snsList">
                        <KakaoLogin className="snsBtn snsLinkKa" style={{}} token='d51ac7189be423197f3a6a450e47d47a' onSuccess={kakaoOnSuccess} onFail={console.error} >
                            카카오 로그인
                            </KakaoLogin>
                            {tooltipShow && lastLogin === 'K'?(
                            <div className="tooltipWr">
                                <p className="txt">최근 사용한 로그인 방법입니다.</p>
                                <button type="butotn" className="xBtn" onClick={(e)=>setTooltipShow(false)}><BsXLg /></button>
                            </div>
                            ):null}
                        </li>
                        <li className="snsList">
                        <LineLogin
                            clientID='2006289192'
                            clientSecret='c980b29f955a9694e8f0528d7203318a'                                                                
                            redirectURI='https://m.salee.co.kr/Login'
                            scope='profile'
                            onSuccess={lineOnSucess}
                        />

                            {tooltipShow && lastLogin === 'L'?(
                            <div className="tooltipWr">
                                <p className="txt">최근 사용한 로그인 방법입니다.</p>
                                <button type="butotn" className="xBtn" onClick={(e)=>setTooltipShow(false)}><BsXLg /></button>
                            </div>
                            ):null}
                        </li>
                        <li className="snsList">
                        <AppleSignin
                            /** Auth options passed to AppleID.auth.init() */
                            authOptions={{
                                /** Client ID - eg: 'com.example.com' */
                                clientId: 'salee.co.kr',
                                /** Requested scopes, seperated by spaces - eg: 'email name' */
                                scope: 'email name',
                                /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
                                redirectURI: 'https://m.salee.co.kr',
                                /** State string that is returned with the apple response */
                                state: 'state',
                                /** Nonce */
                                nonce: 'nonce',
                                /** Uses popup auth instead of redirection */
                                usePopup: true,
                            }} // REQUIRED
                            
                            
                            
                            onSuccess={appleOnSucess} // default = undefined
                            /** Called upon signin error */
                            onError={(error) => console.error(error)} // default = undefined
                            /** Skips loading the apple script if true */
                            skipScript={false} // default = undefined
                            
                            
                            /** render function - called with all props - can be used to fully customize the UI by rendering your own component  */
                            render={(props) => <button className="snsBtn snsLinkAp" {...props}>애플 로그인</button>}
                        />
                            {tooltipShow && lastLogin === 'A'?(
                            <div className="tooltipWr">
                                <p className="txt">최근 사용한 로그인 방법입니다.</p>
                                <button type="butotn" className="xBtn" onClick={(e)=>setTooltipShow(false)}><BsXLg /></button>
                            </div>
                            ):null}
                        </li>
                        <li className="snsList">
                            <button class="snsBtn snsLinkSl" type="button">살리 로그인</button>
                        </li>
                    </ul>
                </div>
                <div className="pd20 pt0 loginWr" style={{display:'none'}}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <ul className="dfColG12">
                            {!isFindPwOpen?(
                            <li className="idLi">
                                <p>{t(`Message.personal_sign_up_info_input_email`)} </p>
                                <input maxLength={60} type="text" placeholder={t(`Message.ordrr_form_hint_email`)} {...register("userId", { required: t(`Message.ordrr_form_required_email`), pattern: {value: emailRegex, message: t(`Message.ordrr_form_invalid_email`)}})}/>
                                {errors.userId && <p role="alert" className="alertRed">{errors.userId.message}</p>}
                            </li>
                            ):null}
                            {idCheck && !errors.userId?
                            <li className="pwLi">
                                <p>{t(`Message.personal_sign_up_info_input_action_pwd`)}</p>
                                <input type="password" placeholder="Password" {...register("password", { required:t(`Message.personal_sign_up_info_input_action_pwd_required`), minLength:{ value:8, message: "비밀번호는 8자 이상이여야 합니다." }})} />
                                {errors.password && <p role="alert" className="alertRed">{errors.password.message}</p>}
                            </li>:''
                            }
                        </ul>
                        <ul className="dfColG12 mt20">
                            
                            <li>
                                <button type="submit" className="btn48 cFFF orgB mt20 fs16 fw700">{t(`Message.common_msg_continue`)}</button>  
                            </li>
                            <li>
                                <div className="dfcc mt12 findIdPw">
                                    <div  className="findId" onClick={(e)=> setFindPwOpen(true)} >{t(`Message.login_screen_find_password`)}</div>
                                </div>
                            </li>
                        </ul>
                    </form>
                </div>


                <div className="ljbottomTxt">
                    <p className="txtLink">{t(`Message.login_screen_agree_msg`)}</p>
                </div>
            </div>

        </div>        
        ):null}   
        {isTermsOpen ?(
        <JoinTerms modal={true} closeFn={setTermsOpen} setTerms={setTerms}></JoinTerms>
        ):null}

        {isJoinOpen ?(
        <Join modal={true} closeFn={setJoinOpen} termsItems={termsItems} formData={socialUserInfo}></Join>
        ):null}
        
        <Modal
                className="btModal"
                show={modalShow}
                onHide={hideModal }
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title><h3 className="fs15 cNavy">{t(`Message.personal_sign_up_info_input_action_email_cert`)}</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmit2)}>
                        <div className="mailIJ">
                            
                            <div className="wrap">
                                <h3 className="txt cBlue">{getValues('userId')}</h3>
                                <p className="txt">{t(`Message.personal_sign_up_info_input_action_cert_code`)}</p>
                                <input type="text" name="certNum" maxLength={6}  {...register("certNum", { required: modalShow? "필수 응답 항목입니다." : false})} />
                                {errors.certNum && <p role="alert" className="alertRed">{errors.certNum.message}</p>}                            
                            </div>
                            <button type="submit" className="btn48 cFFF orgB fs16 mt12">{t(`Message.personal_sign_up_info_input_button_complate`)}</button>
                        </div>
                    </form>
                    </Modal.Body>

        </Modal>

        <Modal
                className="btModal"
                show={isFindPwOpen}
                onHide={setFindPwOpen }
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title><h3 className="fs15 cNavy">{t(`Message.personal_sign_up_info_input_action_email_cert`)}</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmit3)}>
                        <div className="mailIJ">
                            {!isFindPwCert && !isFindPw?(
                            <div className="wrap">                               
                                <p className="txt">{t(`Message.personal_sign_up_info_input_email`)}</p>
                                <input type="text" name="email" maxLength={60}   {...register("email", { required: isFindPwOpen? t(`Message.ordrr_form_required_email`):false, pattern: {value: emailRegex, message: t(`Message.ordrr_form_invalid_email`)}})}/>
                                {errors.email && <p role="alert" className="alertRed">{errors.email.message}</p>}                            
                            </div>
                            ):null}
                            {isFindPwCert?(
                            <div className="wrap">
                                <h3 className="txt cBlue">{getValues('email')} </h3>
                                <p className="txt">{t(`Message.personal_sign_up_info_input_action_cert_code`)}</p>
                                <input type="text" name="certCode" maxLength={6}  {...register("certCode", { required: isFindPwCert? "필수 응답 항목입니다." : false})} />
                                {errors.certCode && <p role="alert" className="alertRed">{errors.certCode.message}</p>}                            
                            </div>
                            ):null}
                            {isFindPw?(
                                <>
                                <div className="wrap">
                                    <p>새 비밀번호</p>
                                    <input type="password" placeholder="변경하실 비밀번호를 입력해주세요" {...register("newPassword", { required: "필수 응답 항목입니다.", minLength:{ value:8, message: "비밀번호는 8자 이상이여야 합니다." }})} />
                                    {errors.newPassword && <p role="alert" className="alertRed">{errors.newPassword.message}</p>}
                                </div>
                                <div className="wrap">
                                    <p>새 비밀번호 확인</p>                                   
                                    <input type="password" placeholder="변경하실 비밀번호를 한번 더 입력해주세요" {...register("newPasswordCheck", { required: "필수 응답 항목입니다.", minLength:{ value:8, message: "비밀번호는 8자 이상이여야 합니다." },
                                    validate: (val) => {
                                        if (watch('newPassword') !== val) {
                                        return "비밀번호 불일치";
                                        }
                                    }
                                    })  } />
                                    {errors.newPasswordCheck && <p role="alert" className="alertRed">{errors.newPasswordCheck.message}</p>}                                           
                                </div>
                                
                                </>
                            ):null}

                            <button type="submit" className="btn48 cFFF orgB fs16 mt12">{t(`common_msg_next`)}</button>
                        </div>
                    </form>
                    </Modal.Body>

        </Modal>
        </div>  
    );
};